import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageActionsDirective, PageContentDirective, PageSubtitleDirective, PageTitleDirective } from './page.directive';
import { PageComponent } from './page/page.component';
import { ComponentPageHeaderComponent } from './component-page-header/component-page-header.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PageComponent,
    PageHeaderComponent,
    PageActionsDirective,
    PageContentDirective,
    PageSubtitleDirective,
    PageTitleDirective,
    ComponentPageHeaderComponent
  ],
  exports: [
    PageComponent,
    PageHeaderComponent,
    PageActionsDirective,
    PageContentDirective,
    PageSubtitleDirective,
    PageTitleDirective,
    ComponentPageHeaderComponent
  ]
})
export class PageModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/page.module.ts